import { isMobile as isMobileDetected, isMobileOnly as isMobileOnlyDetected } from 'react-device-detect';
import { domElements } from '@cld/upload-widget-common';
import sessionStorage from './storage/sessionStorage';
import localStorage from './storage/localStorage';
import getCamera from './camera';

const { createElement, getElement, removeElement, appendElement } = domElements;

const IS_SAFARI = /^((?!chrome|android|CriOS).)*safari/i.test(navigator.userAgent);

const isMobile = () => isMobileDetected;

const isMobileOnly = () => isMobileOnlyDetected;

const isSafari = () => IS_SAFARI;

const isChromium = () => !!window.chrome;

const getNavigatorMedia = () => {
  const nav = self.navigator;
  return !!(nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia);
};

const listenOnMediaQuery = (mq, listener) => {
  const match = self.matchMedia(mq);
  match.addListener(listener);
  return match;
};

const doLater = (action, ms) => {
  const stId = setTimeout(action, ms);
  return () => clearTimeout(stId);
};

const openWindow = (url, name, width = 570, height = 440) => {
  const popup = { width, height };
  const popupStr = `width=${popup.width},height=${popup.height},
            top=${((self.outerHeight - popup.height) / 2).toString()},
            left=${((self.outerWidth - popup.width) / 2).toString()}`;

  return self.open(url, name, popupStr);
};

// element.offsetParent is null in case it has a parent element with display none
const isVisibleAndTabbable = (element) => +element.attributes.tabindex.value > -1 && !element.attributes.disabled && element.offsetParent;

const trackDeviceOrientation = (cb) => {
  const trackAndCall = () => {
    cb(self.orientation);
  };

  self.addEventListener('orientationchange', trackAndCall);

  trackAndCall(); // send the current value to start off

  return () => {
    // return a method to stop the tracking
    self.removeEventListener('orientationchange', trackAndCall);
  };
};

export {
  isSafari,
  isMobile,
  isMobileOnly,
  getNavigatorMedia,
  listenOnMediaQuery,
  doLater,
  openWindow,
  sessionStorage,
  localStorage,
  getCamera,
  createElement,
  getElement,
  removeElement,
  appendElement,
  trackDeviceOrientation,
  isChromium,
  isVisibleAndTabbable,
};
